import VStack from "../../../components/layout/VStack/VStack";
import Dialog from "../../../components/ui/Dialog/Dialog";
import Text from "../../../components/typography/Text/Text";
import Button from "../../../components/ui/Button/Button";
import { useTranslation } from "react-i18next";
export const EditBirthDateConfirmDialog = ({ isShow, onClose }) => {
  const { t } = useTranslation("requirement");
  return (
    <Dialog isShow={isShow} onClose={onClose} contentMode="built-in">
      <VStack
        gap="16px"
        align="center"
        justify="center"
        style={{ minWidth: "250px" }}
      >
        <img
          width={59}
          height={59}
          src="/assets/img/ci/icon/warn.svg"
          alt="warn"
        />
        <Text weight="bold">{t("editProfile.areYouSure")}</Text>
        <Text align="center" variant="body2">
          {t("editProfile.areYouSureDesc")}
        </Text>
        <Button onClick={onClose} variant="primary" fullWidth>
          {t("editProfile.cancel")}
        </Button>
        <Button type="submit" variant="outlined" fullWidth>
          {t("editProfile.confirm")}
        </Button>
      </VStack>
    </Dialog>
  );
};
